import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function nonZeroPostalValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    // Return null ONLY if control value is null, undefined, or empty string
    if (control.value === null || control.value === undefined || control.value === '') {
      return null;
    }

    const value = control.value.toString();
    
    // Check if there's at least one digit
    if (!/\d/.test(value)) {
      return { pattern: true };
    }

    // Pattern explanation:
    // ^               - Start of string
    // (?!             - Start negative lookahead
    //   [0\s-]*       - Any number of zeros, spaces, or dashes
    //   $             - Until the end of string
    // )               - End negative lookahead
    // [a-zA-Z\d\s-]+  - One or more letters (any case), digits, spaces, or dashes
    // $               - End of string
    const pattern = /^(?![0\s-]*$)[a-zA-Z\d\s-]+$/;

    const isValid = pattern.test(value);

    return !isValid ? { pattern: true } : null;
  };
}